export default __webpack_public_path__ + "static/media/Path3357.51a901ab.svg";